import {
  ACTION_CREATE,
  ACTION_DETAILS,
  ACTION_UPDATE,
} from "models/role/action";
import { SUBJECT_CASH_MANAGEMENT_PROVIDER_SETUP } from "models/role/subject";
import { lazyRetry } from "utils/lazyRetry";

import { PAGE_URLS } from "../constants/PageUrls";

import type { Route } from "routes/RouteModel";

const ProviderCreate = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CashManagementProviders" */
      "../pages/provider-customer-config/Create"
    ),
  "CashManagementProviders"
);
const ProviderList = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CashManagementProviders" */
      "../pages/provider-customer-config/List"
    ),
  "CashManagementProviders"
);
const ProviderDetails = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CashManagementProviders" */
      "../pages/provider-customer-config/Details"
    ),
  "CashManagementProviders"
);
const ProviderEdit = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CashManagementProviders" */
      "../pages/provider-customer-config/Edit"
    ),
  "CashManagementProviders"
);

export const providerCustomerConfigRoutes: Route[] = [
  {
    i18nName: "Provider Configuration",
    path: PAGE_URLS.providerConfigList,
    component: ProviderList,
    showChildrenInSidebar: false,
    can: {
      do: ACTION_DETAILS,
      on: SUBJECT_CASH_MANAGEMENT_PROVIDER_SETUP,
    },
    children: [
      {
        i18nName: "Create provider configuration",
        path: PAGE_URLS.providerConfigCreate,
        component: ProviderCreate,
        can: {
          do: ACTION_CREATE,
          on: SUBJECT_CASH_MANAGEMENT_PROVIDER_SETUP,
        },
      },
      {
        i18nName: "Provider configuration details",
        path: PAGE_URLS.providerConfigDetails,
        component: ProviderDetails,
        can: {
          do: ACTION_DETAILS,
          on: SUBJECT_CASH_MANAGEMENT_PROVIDER_SETUP,
        },
      },
      {
        i18nName: "Edit provider configuration",
        path: PAGE_URLS.providerConfigEdit,
        component: ProviderEdit,
        can: {
          do: ACTION_UPDATE,
          on: SUBJECT_CASH_MANAGEMENT_PROVIDER_SETUP,
        },
      },
    ],
  },
];
